<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div [ngClass]="{ dialogContainer: isDialog }" class="flex items-center justify-center w-full h-full py-8 px-4 bg-card sm:p-12 md:p-16">
        <div
            [ngClass]="{
                'w-full': isDialog,
                'w-[80%] md:w-[70%] lg:w-[30%] lg:min-w-[350px] md:max-w-120': !isDialog,
            }"
            class="mx-auto sm:mx-0"
        >
            <!-- Logo -->
            @if (!isDialog) {
                <div class="w-20">
                    <img src="assets/images/logo/logo-bl.png" />
                </div>
            }

            <!-- Title -->
            @if (!isDialog) {
                <div class="mt-3 text-4xl font-extrabold tracking-tight leading-tight">
                    Gaman að sjá þig
                    {{ nameLastLoggedIn ? ' aftur ' + nameLastLoggedIn : '' }}
                </div>
            }
            @if (isDialog) {
                <div class="text-4xl font-extrabold tracking-tight leading-tight">
                    Auðkennið þitt er runnið út
                    {{ nameLastLoggedIn ? nameLastLoggedIn : '' }}
                </div>
            }
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>Auðkenndu þig með <strong>rafrænum skilríkjum</strong></div>
            </div>

            <!-- Sign in form -->
            <form [formGroup]="signInForm" #signInNgForm="ngForm" (ngSubmit)="signIn()">
                <mat-tab-group
                    class="sm:px-2 hjalp-tab-group sign-in-tab-group fade-in-left"
                    [animationDuration]="'0'"
                    [(selectedIndex)]="selectedPanelIndex"
                    (selectedTabChange)="tabChanged($event)"
                >
                    <mat-tab [label]="'label_phone_number' | translate">
                        <mat-form-field class="w-full">
                            <mat-label>{{ 'label_phone_number' | translate }}</mat-label>
                            <input id="phone" (keyup)="phoneKeyUp($event)" matInput [formControlName]="'phone'" />
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:phone_iphone'" matPrefix></mat-icon>
                            @if (signInForm.get('phone').hasError('required')) {
                                <mat-error>
                                    {{ 'error_phone_number_required' | translate }}
                                </mat-error>
                            }
                            @if (signInForm.get('phone').hasError('validPhone') && !signInForm.get('phone').hasError('required')) {
                                <mat-error>
                                    {{ 'error_phone_number_valid' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </mat-tab>
                    <mat-tab [label]="'label_audkenni_app' | translate">
                        <mat-form-field class="w-full">
                            <mat-label>{{ 'label_ssn' | translate }}</mat-label>
                            <input id="phone" (keyup)="ssnKeyUp($event)" matInput [formControlName]="'ssn'" />
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                            @if (signInForm.get('ssn').hasError('required')) {
                                <mat-error>
                                    {{ 'error_ssn_required' | translate }}
                                </mat-error>
                            }
                            @if (
                                signInForm.get('ssn').hasError('validKennitalaWithHyphen') && !signInForm.get('ssn').hasError('required')
                            ) {
                                <mat-error>
                                    {{ 'error_ssn_valid' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </mat-tab>
                </mat-tab-group>

                <!-- Actions -->
                <div class="inline-flex items-end justify-between w-full">
                    <mat-checkbox [color]="'primary'" class="ml-4" [formControlName]="'rememberMe'" (change)="rememberMeChange($event)">
                        {{ 'label_remember_me' | translate }}
                    </mat-checkbox>
                </div>

                <!-- Submit button -->
                <button class="fuse-mat-button-large w-full mt-4" mat-flat-button [color]="'primary'" [disabled]="signInForm.disabled">
                    @if (!signInForm.disabled) {
                        <span>
                            {{ 'label_login' | translate }}
                        </span>
                    }
                    @if (signInForm.disabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                    }
                </button>

                <!-- Alert -->
                @if (showAlert) {
                    <fuse-alert class="mt-4 -mb-4" [showIcon]="false" [type]="alert.type">
                        {{ alert.message }}
                    </fuse-alert>
                }

                @if (signInForm.disabled && initiateResponse && initiateResponse.verificationCode != null) {
                    <fuse-alert [type]="'primary'" class="mt-4 -mb-4" [appearance]="'border'">
                        <span fuseAlertTitle
                            >Öryggistalan þín er: <span id="verificationCode">{{ this.initiateResponse.verificationCode }}</span></span
                        >
                    </fuse-alert>
                }

                <!-- Separator -->
                <div class="flex items-center mt-8">
                    <div class="flex-auto mt-px border-t"></div>
                    <div class="mx-2 text-secondary">
                        {{ 'label_safe_channel' | translate }}
                    </div>
                    <div class="flex-auto mt-px border-t"></div>
                </div>

                <!-- Single sign-on buttons -->
                <div class="flex items-center mt-2 space-x-6">
                    <a href="http://app.audkenni.is" target="_blank" class="flex-auto relative max-w-2/3 pb-3">
                        <img src="/assets/images/logos/audkenni-download.png" />
                    </a>
                    <span class="flex-auto max-w-2/3">
                        <img src="/assets/images/logos/ssl-secure.png" />
                    </span>
                </div>
            </form>
        </div>
    </div>
</div>
